import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';

const Fields = () =>(
    <div style={{ display: 'flex', gap: '10px' }}>
    <Skeleton variant="rectangular" width={500} height={50} />
    <Skeleton variant="rectangular" width={500} height={50} />
    <Skeleton variant="rectangular" width={500} height={50} />
    <Skeleton variant="rectangular" width={500} height={50} />
</div>
)

export default function FormShimmer() {

  return (
    <Grid md={12}>
        <Stack spacing={4} sx={{ mt: 2}} >
          <Skeleton variant="h1" sx={{ fontSize: '4rem' }} animation="wave" />
          {[...Array(4)].map((_, index) => (
          <Fields key={index} />
            ))}
          <Skeleton variant="h1" sx={{ fontSize: '4rem' }} animation="wave" />
          {[...Array(4)].map((_, index) => (
          <Fields key={index} />
            ))}
          <Skeleton variant="h1" sx={{ fontSize: '4rem' }} animation="wave" />

        </Stack>

    </Grid>
  );
}